import React from "react";
import "./ActiveProjectChallenge1.css";
import ProgressStepper from "components/Project/ProgressStepper";
import ProjectBanner from "components/Project/ProjectBanner";
import AxiosConfig from "axiosConfig";
import ProjectOldInfo from "components/Project/Details/ProjectOldInfo";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import Collapsible from "react-collapsible";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

class ActiveProjectChallenge1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectSlug: this.props.match.params.slug,
      projectName: "",
      projectBanner: "",
      projectVideoName: "",
      projectVideo: "",
      projectMission: "",
    };
  }

  componentDidMount() {
    const projectSlug = this.props.match.params.slug;
    AxiosConfig.get(`impactprojects/project/${projectSlug}/`)
      .then((res) => {
        this.setState({
          projectName: res.data["name"],
          projectBanner: res.data["banner"],
          projectVideo: res.data["video"],
          projectVideoName: res.data["project_video_name"],
          projectMission: res.data["mission"],
          projectExploration: res.data["exploration"],
          projectReferences: res.data["references"],
          projectGoal: res.data["goal"],
          openReferences: false,
        });
      })
      .catch();
  }

  // toggle() {
  //   $('.panel-collapse').on('show.bs.collapse', function () {
  //     $(this).siblings('.panel-heading').addClass('active');
  //   });

  //   $('.panel-collapse').on('hide.bs.collapse', function () {
  //     $(this).siblings('.panel-heading').removeClass('active');
  //   });
  // }

  buttonHandler() {
    AxiosConfig.put(`impactprojects/update/Challenge/`, {
      slug: this.props.match.params.slug,
    })
      .then(
        this.props.history.push(
          `/projects/${this.props.match.params.slug}/active-project-challenge-2`
        )
      )
      .catch();
  }

  render() {
    return (
      <div className="header_main">
        <link
          href="//netdna.bootstrapcdn.com/twitter-bootstrap/2.3.2/css/bootstrap-combined.no-icons.min.css"
          rel="stylesheet"
        ></link>
        <link
          href="//netdna.bootstrapcdn.com/font-awesome/3.2.1/css/font-awesome.css"
          rel="stylesheet"
        ></link>
        <div className="page_info_hr_content_main">
          <div className="header_step_banner_main">
            <div className="banner_main">
              <div className="banner_main_content">
                <ProjectBanner image={this.state.projectBanner} />
              </div>
            </div>

            <div className="stepper_main">
              <div className="stepper_main_content">
                <ProgressStepper currentStep="0" />
              </div>
            </div>
          </div>
          {/*change name from slug to project*/}
          <ProjectOldInfo project={this.state.projectSlug} />
        </div>

        <div className="page_main">
          <div className="page_info_vr_content_main">
            <ProjectOldInfo vertical={true} project={this.state.projectSlug} />
          </div>
          <div className="page_details_main">
            <div className="project-banner">
              <ProjectBanner image={this.state.projectBanner} />
            </div>
            <div className="stepper_main_content">
              <ProgressStepper currentStep="1" />
            </div>
            <div className="page_details_content_main">
              <h2 className="textHeader">CHALLENGE 1: Exploration</h2>
              <p>
                <br />
                <div
                  className="insideContent"
                  dangerouslySetInnerHTML={{
                    __html: this.state.projectExploration,
                  }}
                ></div>

                {/* <h2 className="textHeader" id="references_collapse_btn" onClick={this.toggle.bind(this)} >References</h2>
                <div
                  className="insideContent" id={"projectReferences"+ (this.state.openReferences ? ' in' : '')}
                  dangerouslySetInnerHTML={{
                    __html: this.state.projectReferences,
                  }}
                  >
                </div> */}

                <Collapsible trigger="References">
                  <div
                    className="insideContent"
                    dangerouslySetInnerHTML={{
                      __html: this.state.projectReferences,
                    }}
                  ></div>
                </Collapsible>
              </p>

              {/* <div>
                <h2 className="textHeader">Project Goal</h2>
                <a
                  style={{ color: "black", fontWeight: "500" }}
                  className="insideContent"
                  href={this.state.projectGoal}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Click to view ({this.state.projectGoal})
                </a>
              </div> */}
            </div>
            <br />
            {/* <div className="page_details_content_main">
              <a
                href="https://www.pinterest.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <h5 className="textHeader">
                  <span>Explore More</span>
                </h5>
              </a>
            </div> */}
            <div className="page_details_content_main mt-15 d-flex justify-space-between align-items-baseline">
              <a
                href="https://www.pinterest.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="textHeader"
              >
                Explore More
              </a>
              <a href="https://www.pinterest.com/" target="_blank">
                <FontAwesomeIcon
                  icon={faChevronRight}
                  color="#1A3867"
                  style={{ marginRight: "10px", float: "right" }}
                />
              </a>
            </div>
            <div className="buttonDiv">
              <RoundedButton
                title="&nbsp;&nbsp;&nbsp;Next&nbsp;&nbsp;&nbsp;"
                buttonClassName="background_dark_orange"
                textThemeClassName="text_medium text_white"
                handleOnClick={this.buttonHandler.bind(this)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ActiveProjectChallenge1;
